import { Controller } from '@hotwired/stimulus'

// Computes and displays the "First send" date for each scheduling card
// based on the selected day, hour, timezone, and start week option.
export default class extends Controller {
  static targets = ['firstSend']

  connect() {
    this.update()
  }

  update() {
    const startNextWeek = document.querySelector('input[name="start_week"][value="next_week"]')?.checked
    const timezone = document.querySelector('select[name="timezone"]')?.value || 'UTC'

    this.firstSendTargets.forEach(target => {
      const card = target.closest('[data-scheduling-type]')
      if (!card) return

      const type = card.dataset.schedulingType
      const daySelect = card.querySelector(`select[name="schedulings[${type}][day]"]`)
      const hourSelect = card.querySelector(`select[name="schedulings[${type}][hour]"]`)

      if (!daySelect || !hourSelect) return

      const dayName = daySelect.value
      const hour = parseInt(hourSelect.value)

      const nextDate = this.computeNextSend(dayName, hour, startNextWeek)
      if (nextDate) {
        const formatted = nextDate.toLocaleDateString('en-US', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })
        const timeStr = `${hour}:00 ${hour < 12 ? 'AM' : 'PM'}`
        target.innerHTML = `<i class="fa fa-calendar-alt me-1"></i> First send: <strong>${formatted} at ${timeStr}</strong>`
      }
    })
  }

  computeNextSend(dayName, hour, startNextWeek) {
    const days = { sunday: 0, monday: 1, tuesday: 2, wednesday: 3, thursday: 4, friday: 5, saturday: 6 }
    const targetDay = days[dayName]
    if (targetDay === undefined) return null

    const now = new Date()
    const today = now.getDay()
    let daysUntil = targetDay - today

    if (daysUntil < 0 || (daysUntil === 0 && now.getHours() >= hour)) {
      daysUntil += 7
    }

    if (startNextWeek) {
      daysUntil += 7
    }

    const nextDate = new Date(now)
    nextDate.setDate(now.getDate() + daysUntil)
    nextDate.setHours(hour, 0, 0, 0)

    return nextDate
  }
}
